<div
  class="modal {{ size() }}"
  [ngClass]="{ closed: !visible, 'd-none': !opened() }"
>
  <div class="modal-header" [ngClass]="{ 'm-0': noGap() }">
    <h4>{{ title() }}</h4>
    <button (click)="close()" class="modal-close">
      <ng-icon name="xmark" size="24"></ng-icon>
    </button>
  </div>
  <div class="modal-content" #content id="popover-content">
    @if (loading()) {
    <div class="modal-loading">
      <app-loading-spinner size="md" [label]="dictionaryService.get('Loading')" />
    </div>
    } @else {
    <ng-content></ng-content>
    }
  </div>
</div>

<div
  class="modal-backdrop"
  (click)="close()"
  [ngClass]="{ closed: !visible, 'd-none': !opened() }"
></div>
